// extracted by mini-css-extract-plugin
export default {"action":"deleteAction_action__BY5kf"};